import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
	selector: 'app-username-modal',
	templateUrl: './username-modal.component.html',
	styleUrls: ['./username-modal.component.scss'],
})
export class UsernameModalComponent {
	uForm = new FormGroup({
		username: new FormControl<string>('', Validators.required),
	});

	constructor(
		private authService: AuthenticationService,
		private modalCtrl: ModalController,
		private toastService: ToastService,
	) {}

	submit() {
		if (this.uForm.invalid) {
			return;
		}
		const { username } = this.uForm.value;
		this.authService.updateUsername(username!).subscribe({
			next: () => this.modalCtrl.dismiss(username, 'confirm'),
			error: () => this.toastService.showToastOnError('Der Benutzername ist bereits vergeben'),
		});
	}
}
